export type TextSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl';

interface TextSizeConfig {
  fontSize: string;
  fontWeight: string;
  lineHeight: string;
  letterSpacing: string;
}

export const TEXT_SIZE_MAP: Record<TextSize, TextSizeConfig> = {
  xs: {
    fontSize: 'var(--text-xs)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-loose)',
    letterSpacing: 'var(--tracking-normal)',
  },
  sm: {
    fontSize: 'var(--text-sm)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-relaxed)',
    letterSpacing: 'var(--tracking-tight)',
  },
  base: {
    fontSize: 'var(--text-base)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-loose)',
    letterSpacing: 'var(--tracking-normal)',
  },
  lg: {
    fontSize: 'var(--text-lg)',
    fontWeight: 'var(--font-weight-bold)',
    lineHeight: 'var(--leading-relaxed)',
    letterSpacing: 'var(--tracking-normal)',
  },
  xl: {
    fontSize: 'var(--text-xl)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-snug)',
    letterSpacing: 'var(--tracking-tight)',
  },
  '2xl': {
    fontSize: 'var(--text-2xl)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-snug)',
    letterSpacing: 'var(--tracking-tight)',
  },
  '3xl': {
    fontSize: 'var(--text-3xl)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-tight)',
    letterSpacing: 'var(--tracking-tight)',
  },
  '4xl': {
    fontSize: 'var(--text-4xl)',
    fontWeight: 'var(--font-weight-semibold)',
    lineHeight: 'var(--leading-tight)',
    letterSpacing: 'var(--tracking-tighter)',
  },
};

export type FontWeight = 'light' | 'normal' | 'semibold' | 'bold';

export const FONT_WEIGHT_MAP: Record<FontWeight, string> = {
  light: 'var(--font-weight-light)',
  normal: 'var(--font-weight-normal)',
  semibold: 'var(--font-weight-semibold)',
  bold: 'var(--font-weight-bold)',
};

export type TextAlignment = 'left' | 'center' | 'right' | 'justify';

export type FontFamily = 'sans' | 'display';

export const FONT_FAMILY_MAP: Record<FontFamily, string> = {
  sans: 'var(--font-sans)',
  display: 'var(--font-display)',
};

export type Gradient = 'primary' | 'secondary' | 'tertiary';

export type TextTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'p';

export type WhiteSpace = 'normal' | 'pre-line' | 'nowrap' | 'pre-wrap';

export interface DynamicTextConfig {
  tag?: TextTag;
  text: string;
  size?: TextSize;
  color?: string;
  fontWeight?: FontWeight;
  fontFamily?: FontFamily;
  alignment?: TextAlignment;
  gradient?: Gradient;
  whiteSpace?: WhiteSpace;
}
